export const tr = {
  nav: {
    home: "Ana Sayfa",
    projects: "Projeler",
    services: "Hizmetler",
    about: "Hakkımızda",
    brands: "Markalar",
    contact: "İletişim",
    cta: "Projenizi Başlatalım",
    langLabel: "Dil / Language:",
    whatsapp: "WhatsApp",
    email: "Email"
  },
  footer: {
    description: "Strateji, tasarım, prodüksiyon ve teknolojiyi tek çatı altında buluşturan yaratıcı iletişim ajansı.",
    servicesTitle: "Hizmetlerimiz",
    quickLinksTitle: "Hızlı Linkler",
    contactTitle: "Bize Ulaşın",
    address: "Meşrutiyet Mah., Şehit İsmet Armağan Sok., No: 7, Nişantaşı, Şişli, İstanbul",
    whatsappBtn: "WhatsApp'tan Yazın",
    allRightsReserved: "Tüm hakları saklıdır.",
    privacy: "Gizlilik Politikası",
    kvkk: "KVKK Aydınlatma Metni",
    cookie: "Çerez Politikası"
  },
  home: {
    heroTag: "WE24 - DİJİTAL İLETİŞİM AJANSI",
    heroTitle: "Fikirleri görüntüye, markaları etkiye dönüştürüyoruz.",
    heroSubtitle: "Prodüksiyondan post-prodüksiyona, sosyal medyadan web ve yazılıma kadar markaların tüm iletişim yolculuğunu tek çatı altında tasarlıyor, üretiyor ve büyütüyoruz.",
    exploreProjects: "Projeleri Keşfet",
    contactUs: "Projenizi Konuşalım",
    featuredProjectsTitle: "Seçili İşler",
    featuredProjectsSubtitle: "Stratejiden sete, kurgudan yayına uzanan farklı disiplinlerden seçilmiş projeler.",
    viewAllProjects: "Tüm Projeleri Gör",
    capabilitiesTitle: "Neler Yapıyoruz?",
    capabilitiesSubtitle: "Markanızın ihtiyaç duyduğu tüm yaratıcı ve dijital üretim disiplinlerinde uzmanlaşıyoruz.",
    processTitle: "Üretim Modelimiz",
    processSubtitle: "Hızlı, şeffaf ve ölçülebilir adımlarla hedefe odaklanan çalışma prensibimiz.",
    metricsTitle: "Rakamlarla WE24",
    ctaTitle: "Sıradaki projenizi birlikte üretelim.",
    ctaSubtitle: "Bir film, dijital kampanya, canlı yayın, sosyal medya sistemi ya da özel yazılım… İhtiyacınızı anlatın, doğru üretim modelini birlikte kuralım.",
    ctaBtn: "Projenizi Anlatın"
  },
  services: {
    title: "Hizmetlerimiz",
    subtitle: "Strateji, tasarım, prodüksiyon ve teknolojiyi tek çatı altında entegre eden esnek üretim modelimizle markanızı dijital dünyada konumlandırıyoruz.",
    categoryLabel: "Kategori",
    exploreDetails: "Detayları Keşfet",
    allServices: "Tüm Hizmetler",
    startNow: "Hemen Başlayalım",
    scopeTitle: "Neler Sunuyoruz?",
    deliverablesTitle: "Neler Teslim Ediyoruz?",
    processTitle: "Çalışma Sürecimiz",
    techSpecsTitle: "Teknoloji, Ekipman ve Altyapı",
    faqTitle: "Sıkça Sorulan Sorular",
    relatedProjectsTitle: "Bu Hizmeti Verdiğimiz Örnek İşler",
    notFound: "Hizmet Bulunamadı",
    notFoundDesc: "Aradığınız hizmet başlığı sistemimizde kayıtlı değildir.",
    backToList: "Hizmetler Listesine Dön"
  },
  projects: {
    title: "İşlerimiz",
    subtitle: "Film, dijital, yayın, tasarım ve teknoloji disiplinlerinde ürettiğimiz seçili çalışmalar.",
    all: "Tümü",
    filterByCategory: "Kategoriye Göre Filtrele",
    client: "Müşteri / Marka",
    year: "Yıl",
    services: "Verilen Hizmetler",
    viewProject: "Projeyi Gör",
    searchPlaceholder: "Proje veya müşteri ara...",
    sortBy: "Sırala:",
    featured: "Öne Çıkanlar",
    newest: "En Yeni",
    alpha: "A - Z",
    notFound: "Proje Bulunamadı",
    notFoundDesc: "Seçtiğiniz filtreye veya arama kelimesine uygun çalışma bulamadık. Filtreleri sıfırlayarak tekrar deneyebilirsiniz.",
    clearFilters: "Filtreleri Temizle",
    backToProjects: "Tüm Projelere Dön",
    nextProject: "Sonraki Proje"
  },
  projectDetail: {
    backToProjects: "Tüm Projelere Dön",
    projectDetails: "Proje Detayları",
    client: "Müşteri",
    year: "Yıl",
    category: "Kategori",
    projectTeam: "Proje Ekibi",
    relatedProjects: "İlginizi Çekebilecek Diğer İşler",
    notFound: "Proje Bulunamadı",
    notFoundDesc: "Aradığınız projeyi bulamadık ya da yayından kaldırılmış olabilir."
  },
  about: {
    tag: "Hakkımızda",
    title: "Farklı disiplinler.\nTek üretim aklı.",
    subtitle: "Kurucu ekibimizin 15 yılı aşan üretim deneyimi; yüzlerce etkinlik, kurumsal film, konser, klip ve dijital projeyi kapsıyor. WE24 Agency, bu birikimi tek bir çatı altında birleştirmek üzere kuruldu.",
    storyTitle: "Hikayemiz & Modelimiz",
    storyP1: "Geleneksel reklam ajanslarının hantal süreçlerini ve farklı üretim ihtiyaçları için ayrı ekiplerle çalışma zorluğunu ortadan kaldırıyoruz. Biz, kreatif stratejiden set ışıklarına, post-prodüksiyon kurgu masalarından web kodlamasına kadar tüm süreçleri kurum içi uzmanlıkla çözüyoruz.",
    storyP2: "Markaların iletişim yolculuğunda tutarlılık, kalite ve hız en önemli değerlerdir. Çekimini yaptığımız bir filmin ruhunu web sitesinin arayüz tasarımlarına aktarıyor, sosyal medya iletişiminde bu sinematik görselliği sürdürülebilir kılıyoruz.",
    valuesTitle: "Değerlerimiz",
    teamTitle: "Üretimin Arkasındaki Akıl",
    studioTitle: "Teknik Altyapımız",
    studioSubtitle: "Üretim gücümüzü modern teknik araçlar ve izole stüdyo ortamımızla destekliyoruz.",
    manifesto: "Tek bir çatı altında strateji, kamera, kod ve kurgu."
  },
  brands: {
    tag: "İş Ortaklarımız",
    title: "Birlikte Ürettiğimiz Markalar",
    subtitle: "Bugüne kadar sinematik prodüksiyon, strateji ve dijital deneyim ürettiğimiz değerli iş ortaklarımız."
  },
  contact: {
    tag: "İletişim",
    title: "Birlikte ne üretebiliriz?",
    subtitle: "Bir projeniz mi var? Detayları form doldurarak paylaşın veya stüdyomuzla doğrudan iletişime geçin. Doğru üretim modelini birlikte kuralım.",
    phone: "Telefon",
    email: "E-posta",
    address: "Stüdyo Adresi",
    directMessage: "Doğrudan mesajlaşmak isterseniz:",
    whatsappBtn: "WhatsApp ile İletişime Geçin",
    whatsappDirect: "WhatsApp ile İletişime Geçin",
    formTitle: "Proje Bilgi Formu",
    fullName: "Ad Soyad",
    company: "Marka / Şirket",
    emailField: "E-posta",
    phoneField: "Telefon",
    service: "İlgilendiğiniz Hizmet",
    selectService: "Hizmet seçin",
    timeline: "Tahmini Zamanlama",
    selectTimeline: "Zaman aralığı seçin",
    budget: "Tahmini Bütçe Aralığı",
    selectBudget: "Bütçe aralığı seçin",
    summary: "Proje Özeti",
    submit: "Talebi Gönder",
    formSuccessTitle: "Talebiniz Alındı",
    formSuccessDesc: "İlginiz için teşekkür ederiz. Proje detaylarınızı inceledikten sonra çekirdek ekibimiz en kısa sürede sizinle iletişime geçecektir.",
    sendNewForm: "Yeni Bir Form Gönder"
  }
};
